// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__fZq50","rootMobile":"styles_rootMobile__1LvFD"};